module.exports = __webpack_public_path__ + "static/media/round_bs.7bf7f5e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/round_bs.png
// module id = 680
// module chunks = 0 1